import { createElement as e } from "../../../../../external/preact/dist/preact.js";
const t = (t, r) => e("div", {
  ...t,
  "aria-hidden": "true"
}, r);
export { t as alternativeLabelContent };
